<template>
  <modal :show="show" :large="true" v-on:close="closeModal">
    <div slot="title">
      <h4>Generate Document</h4>
    </div>
    <div class="row">
      <div class="col-xl-12">
        <div class="form-horizontal">
          <selectlist
            name="type"
            placeholder="Please Letter Head"
            v-model="form.letter_head_id"
            label="Letter Head"
            :options="letterHeads"
            :required="true"
            :show-error="form.errors.has('letter_head_id')"
            :error-message="form.errors.get('letter_head_id')"
            key-name="id"
            v-if="letterHeads.length > 1 && !selectedType?.includes_letter_head"
          ></selectlist>

          <selectlist
            name="type"
            placeholder="Please Select"
            v-model="type"
            label="Document Type"
            :options="generateableTypes"
            :required="true"
            :show-error="form.errors.has('type')"
            helper="Please select the type of document you want to generate"
            :error-message="form.errors.get('type')"
            key-name="identifier"
          ></selectlist>

          <input-block
            name="description"
            label="Description"
            v-model="form.description"
            helper="Optionally add a description of the document you are generating"
          ></input-block>

          <div class="form-group" v-if="selectedType?.includes_third_party">
            <div class="col-lg-4">
              <label class="control-label">Third Party*</label>
            </div>
            <div class="col-lg-8">
              <select
                name="third_party_id"
                id="third_party_id"
                class="form-control"
                v-model="form.third_party_id"
              >
                <option value="">Please Select</option>
                <option
                  :value="thirdParty.id"
                  :key="index"
                  v-for="(thirdParty, index) in thirdParties"
                >
                  {{ thirdParty.full_name }}
                </option>
              </select>
            </div>
          </div>

          <document-placeholders
            :form="form"
            :type="type"
            :incident="incident"
            :thirdPartyId="form.third_party_id"
            :placeholders="placeholders"
            v-if="type"
          ></document-placeholders>
        </div>
      </div>
    </div>
    <div slot="footer">
      <button type="button" v-on:click="closeModal" class="btn btn-danger">
        Close
      </button>
      <form-button :indicator="form.processing()" @clicked="generateDocument">
        Generate Document
      </form-button>
    </div>
  </modal>
</template>
<script>
import debounce from 'lodash/debounce';
import DocumentPlaceholders from '@/components/Modules/Shared/Children/GenerateDocument/DocumentPlaceholders';

export default {
  props: {
    incident: {
      type: String,
      required: true
    },
    show: {
      type: Boolean,
      default: false
    },
    types: {
      type: Array,
      required: true
    }
  },

  components: {
    DocumentPlaceholders
  },

  data() {
    return {
      form: new window.Form({
        letter_head_id: null,
        third_party_id: '',
        type: null,
        description: null,
        placeholders: []
      })
    };
  },

  computed: {
    generateableTypes() {
      return this.types.filter(type => !!type.template_id);
    },

    letterHeads() {
      return this.$store.getters['LetterHeads/all'] || [];
    },

    thirdParties() {
      return this.$store.getters['Incident/thirdParties'] || [];
    },

    selectedType() {
      return this.types.find(type => type.identifier === this.type);
    },

    type: {
      get() {
        return this.form.type;
      },
      set: debounce(function(type) {
        if (this.form.type !== type) {
          this.form.type = type;
        }
      }, 100)
    },

    placeholders() {
      return [];
    }
  },

  mounted() {
    this.$store.commit('LetterHeads/retrieve');
  },

  methods: {
    closeModal() {
      this.form.reset();
      this.$emit('close');
    },

    generateDocument() {
      if (
        !this.selectedType?.includes_letter_head &&
        this.letterHeads.length === 1
      ) {
        this.form.letter_head_id = this.letterHeads[0].id;
      }

      this.form
        .post('/incidents/' + this.incident + '/documents/generate')
        .then(response => {
          this.$emit('generated', response);
          this.form.reset();
        })
        .catch(error => {
          window.toastify.error(
            'Error',
            'Oops, there was an error generating the document'
          );
        });
    }
  }
};
</script>
